<template>
    <v-dialog
        :value="isOpen"
        max-width="500"
        eager
        transition="slide-y-transition"
        persistent
    >
        <v-card>
            <v-card-title>
                <span class="text-h5">Zamykanie karty stop</span>
            </v-card-title>
            <v-card-text>
                <div class="text-subtitle-1">
                    Czy chcesz zamknąć istniejące karty stop?
                </div>
                <v-list>
                    <v-list-item-group>
                        <v-list-item
                            v-for="(stopCard, index) in stopCardsData"
                            :key="index"
                        >
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ stopCard.number }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zamknij"
                    @click="acceptClosing"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { EventBus } from '@/utils/eventBus'

export default {
    name: 'TryToCloseStopCardDialog',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        stopCards: {
            type: Array,
            required: true,
        },
        wayOfClosing: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            stopCardsData: [],
        }
    },
    computed: {
        wayOfClosingId() {
            const wayOfClosingMap = {
                UJ: 20, // Uwaga jakościowa
                RW: 30, // Reklamacja wewnętrzna
            }

            return wayOfClosingMap[this.wayOfClosing]
        },
    },
    mounted() {
        Promise.all(this.stopCards.map((stopCard) => {
            if (stopCard.id)
                return this.$store.dispatch('complaints/getStopCard', stopCard.id)
        }))
            .then((response) => {
                response.forEach(({data}) => data.statusId == 10 && this.stopCardsData.push(data))
            })
    },
    methods: {
        acceptClosing() {
            Promise.all(
                this.stopCardsData.map((stopCard) => {
                    const payload = {
                        ...stopCard,
                        statusId: 20, // Zamknięta
                        wayOfClosingId: this.wayOfClosingId,
                    }

                    return this.$store.dispatch('complaints/updateStopCard', payload)
                })
            )
                .then((response) => {
                    response.forEach(({data}) => EventBus.$emit('stopCardClosed', data))

                    this.$emit('close')
                })
        },
        onClose() {
            setTimeout(() => {
                this.stopCardsData = []
            }, 500)

            this.$emit('close')
        },
    },
}
</script>